<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header text-black p-2">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <div class="d-flex gap-1">
                                    <span class="cursor-pointer text-theme" @click="prepareDateRange('prev')">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-left-icon lucide-square-arrow-left"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="m12 8-4 4 4 4"/><path d="M16 12H8"/></svg>
                                    </span>
                                    <span class="cursor-pointer text-theme" @click="prepareDateRange('next')">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-right-icon lucide-square-arrow-right"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M8 12h8"/><path d="m12 16 4-4-4-4"/></svg>
                                    </span>
                                </div>
                                <div>
                                    Due Date Services ({{ dataTimeFormat(startDate, 'DD MMM')}} - {{ dataTimeFormat(endDate, 'DD MMM, YYYY') }})
                                </div>
                            </div>
                            <div class="d-flex gap-1 align-items-center">
                                <div class="d-flex gap-1">
                                    <select class="form-select form-select-sm" v-model="filters.searchType" @change="changeFilterType">
                                        <option value="last_week">Last Week</option>
                                        <option value="this_week">This Week</option>
                                        <option value="next_week">Next Week</option>
                                        <option value="last_month">Last Month</option>
                                        <option value="this_month">This Month</option>
                                        <option value="next_month">Next Month</option>
                                        <option value="last_year">Last Year</option>
                                        <option value="this_year">This Year</option>
                                        <option value="next_year">Next Year</option>
                                    </select>
                                    <input type="text" class="form-control form-control-sm" placeholder="Search..." v-model="filters.search">
                                </div>
                                <div class="d-flex gap-1">
                                    <Download
                                        :size="24"
                                        :stroke-width="2"
                                        :class="'text-theme cursor-pointer'"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Export to CSV"
                                        @click="downloadDueDateServices"
                                    />
                                    <MapPinPlus
                                        v-if="dueDateDisplayMap"
                                        :size="24"
                                        :stroke-width="2"
                                        :class="'text-theme cursor-pointer'"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Show Map View"
                                        @click="dueDateDisplayMap = !dueDateDisplayMap"
                                    />
                                    <MapPinOff
                                        v-else
                                        :size="24"
                                        :stroke-width="2"
                                        :class="'text-theme cursor-pointer'"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Show List View"
                                        @click="dueDateDisplayMap = !dueDateDisplayMap"
                                    />
                                </div>
                                



                                <!-- <button type="button" class="btn btn-sm btn-outline-theme" @click="downloadDueDateServices">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-theme" @click="dueDateDisplayMap = !dueDateDisplayMap">
                                    <svg v-if="dueDateDisplayMap" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-off-icon lucide-map-pin-off"><path d="M12.75 7.09a3 3 0 0 1 2.16 2.16"/><path d="M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568"/><path d="m2 2 20 20"/><path d="M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533"/><path d="M9.13 9.13a3 3 0 0 0 3.74 3.74"/></svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus"><path d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"/><circle cx="12" cy="10" r="3"/><path d="M16 18h6"/><path d="M19 15v6"/></svg>
                                </button> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body overflow-auto p-2" style="height: 300px;">
                        <!-- If there is any job in the list then show the map -->
                        <div v-if="dueDateServices.length > 0" v-show="dueDateDisplayMap" class="map-container mb-3">
                            <google-map :orders="dueDateServices" map-id="dueDateServices" :display="dueDateDisplayMap"></google-map>
                        </div>
                        <div class="table-responsive">
                            <table class="table hm-fs-12 align-middle table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col" class="bg-theme">Due Date</th>
                                        <th scope="col" class="bg-theme">Service</th>
                                        <th scope="col" class="bg-theme">Client</th>
                                        <th scope="col" class="bg-theme">Address</th>
                                        <th scope="col" class="bg-theme text-center">Post Code</th>
                                        <th scope="col" class="bg-theme text-center">Phone</th>
                                        <th scope="col" class="bg-theme text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoadingDueDateServices">
                                        <td colspan="7" class="text-center">Processing...</td>
                                    </tr>
                                    <tr v-else-if="filteredServices.length > 0" v-for="(item, index) in filteredServices" :key="index">
                                        <td>{{ $dateTimeFormat($moment(item?.due_date), 'DD-MMM-YYYY') }}</td>
                                        <td class="text-capitalize">{{ item?.service_name }}</td>
                                        <td class="text-capitalize">{{ item?.customer_first_name }}</td>
                                        <td class="text-capitalize">{{ $truncateString(item?.address, 30) }}</td>
                                        <td class="text-uppercase text-center">{{ item?.postal_code }}</td>
                                        <td class="text-center">{{ item?.customer_phone_number }}</td>
                                        <td class="text-center">
                                            <button v-if="item.order_number != '' && item.order_number != null" type="button" class="btn btn-sm btn-outline-theme" @click="$goToPage(`/admin/orders/${item.order_number}`)">View Order</button>
                                            <button v-else type="button" class="btn btn-sm btn-outline-theme" @click="showAssignOrderPopup(item)">Assign Order</button>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="7" class="text-center">No due date service has been added in the system between {{ dataTimeFormat(startDate, 'DD MMM')}} - {{ dataTimeFormat(endDate, 'DD MMM, YYYY') }}.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!-- Assign order to handyman modal dialog -->
     <div
        class="modal fade"
        id="assignOrderModal"
        tabindex="-1"
        data-backdrop="static"
        data-keyboard="false"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <template v-if="!enggDocReady">
                    <div class="modal-header">
                        <h5 class="modal-title">Engineer Document Ready?</h5>
                    </div>
                    <div class="modal-body">
                        <p class="text-center">Engineer Document Ready?</p>
                        <div class="d-flex justify-content-center">
                            <button class="btn btn-danger" @click="cancelItemDrop">No, Cancel</button>
                            <button class="btn btn-theme ms-2" @click="enggDocReady = true">Yes, Ready</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Task Assign To</h5>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3">
                            <div class="col-md-4">
                                <label for="customer_name" class="form-label">Client Name</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="customer_name"
                                    disabled
                                    v-model="assignOrderData.customer_full_name"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="phone_number" class="form-label">Mobile Number</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="phone_number"
                                    disabled
                                    v-model="assignOrderData.customer_phone_number"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="email" class="form-label">Email</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="email"
                                    disabled
                                    v-model="assignOrderData.customer_email"
                                />
                            </div>
                            <div class="col-md-12">
                                <label for="email" class="form-label">Address</label>
                                <textarea
                                    class="form-control disabled"
                                    id="email"
                                    rows="1"
                                    disabled
                                    v-model="assignOrderData.customer_address"
                                ></textarea>
                            </div>
                            <hr/>
                            <div class="col-md-6">
                                <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                                <BookingDatePicker
                                    v-model="assignOrderData.order_booking_date"
                                    :format="'dd-MM-yyyy'"
                                    :time-picker="false"
                                ></BookingDatePicker>
                            </div>
                            <div class="col-md-6">
                                <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                                <VueDatePicker
                                    v-model="assignOrderData.order_booking_time"
                                    time-picker :is-24="false"
                                    :clearable="false"
                                    :minutes-grid-increment="10"
                                    :minutes-increment="15"
                                >
                                    <template #input-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                    </template>
                                </VueDatePicker>
                            </div>
                            <div class="col-md-6">
                                <div class="form-check form-check-inline pb-1">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="hours"
                                        value="hours"
                                        v-model="assignOrderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                                </div>
                                <div class="form-check form-check-inline pb-1">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="full_day"
                                        value="full_day"
                                        v-model="assignOrderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="full_day">Full Day</label>
                                </div>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="assign_duration"
                                    :class="{'disabled': assignOrderData.assigned_duration_type === 'full_day'}"
                                    :disabled="assignOrderData.assigned_duration_type === 'full_day'"
                                    v-model="assignOrderData.assigned_duration"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                                <VueSelect
                                    v-model="assignOrderData.handyman_id"
                                    :items="handymanOptions"
                                    :multiple="true"
                                    :placeholder="'Select Handyman'"
                                ></VueSelect>
                                <small v-if="handymanOptions.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <a
                            type="button"
                            class="text-theme pe-3"
                            data-bs-dismiss="modal"
                            @click="cancelItemDrop"
                        >Cancel</a>
                        <button
                            type="button"
                            class="btn btn-theme btn-sm"
                            v-text="isLoading ? 'Loading...' : 'Assign Task'"
                            @click="assignOrder"
                        ></button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import GoogleMap from './../GoogleMap';
import VueSelect from "../partials/VueSelect";
import { appMixin } from '../../mixin/appMixin';
import {
    MapPinPlus,
    Download,
    MapPinOff
} from 'lucide-vue-next';

export default {
    name: 'DueDateSummary',
    mixins: [appMixin],
    components: {
        GoogleMap,
        VueSelect,
        MapPinPlus,
        MapPinOff,
        Download
    },
    data() {
        return {
            dueDateServices: [],
            isLoadingDueDateServices: true,
            dueDateDisplayMap: false,
            isLoading: false,
            enggDocReady: false,
            assignOrderData: {},
            startDate: this.moment(new Date()),
            endDate: this.moment(new Date()).add(1, 'month'),
            filters: {
                search: '',
                searchType: 'this_month'
            }
        }
    },
    mounted() {
        this.getDueDateSummary();
    },
    computed: {
        handymanOptions() {
            let schedules = this.$store.state.availableSchedules;

            let options = [];

            const dateToFind = this.$moment(this.assignOrderData.order_booking_date).utc().format('YYYY-MM-DD');
            const timeToFind =  this.$moment(`${dateToFind} ${this.assignOrderData.order_booking_time.hours}:${this.assignOrderData.order_booking_time.minutes} :00`, 'YYYY-MM-DD HH:mm:ss');

            Object.keys(schedules).forEach((handymanId) => {
                schedules[handymanId].forEach((schedule) => {
                    const startTime = this.$moment(`${schedule.schedule_date} ${schedule.start_time}`, 'YYYY-MM-DD HH:mm:ss');
                    const endTime = this.$moment(`${schedule.schedule_date} ${schedule.end_time}`, 'YYYY-MM-DD HH:mm:ss');
                    if (schedule.schedule_date === dateToFind && timeToFind.isBetween(startTime, endTime,undefined, '[]')) {
                        let exists = options.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });
                        // If it doesn't exist, push the new option
                        if (!exists) {
                            options.push({
                                id: schedule.handyman_id,
                                text: schedule.full_name + ' (' + this.$moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + this.$moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                                name: schedule.full_name + ' (' + this.$moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + this.$moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                            });
                        }
                    }
                });
            });

            return options;
        },
        filteredServices() {
            const query = this.filters.search.toLowerCase();
            return this.dueDateServices.filter((service) => {
                // Filter by search term
                return service.service_name.toLowerCase().includes(query) ||
                    service.customer_first_name.toLowerCase().includes(query) ||
                    service.customer_email.toLowerCase().includes(query) ||
                    service.customer_phone_number.toLowerCase().includes(query) ||
                    service.customer_address.toLowerCase().includes(query) ||
                    service.postal_code.toLowerCase().includes(query);
            });
        }
    },
    methods: {
        getDueDateSummary() {
            let self = this;
            this.isLoadingDueDateServices = true;
            axios.post('/admin/dashboard/stats?action=due_date_services', {
                action: 'due_date_services',
                start_date: this.startDate,
                end_date: this.endDate
            })
                .then(response => {
                    self.dueDateServices = response.data;
                    self.isLoadingDueDateServices = false;
                })
        },
        downloadDueDateServices() {
            // Define CSV headers
            const headers = ['Customer Name', 'Customer Email', 'Customer Phone', 'Contact Person', 'Full Address', 'Postal Code', 'Service Name', 'Due Date'];
            // Create CSV content
            let csv = headers.join(',') + '\n';

            this.filteredServices.forEach(service => {
                csv += `"${service.customer_full_name}","${service.customer_email}","${service.customer_phone_number}","${service.acp_full_name}","${service.full_address}","${service.postal_code}","${service.service_name}","${this.dataTimeFormat(service.due_date, 'DD/MM/YYYY')}"\n`;
            });

            // Create and trigger download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'due_date_services.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        showAssignOrderPopup(item) {
            this.assignOrderData = item;
            this.assignOrderData.handyman_id = [];
            this.assignOrderData.booking_date = this.dataTimeFormat(item.due_date,"YYYY-MM-DDTHH:mm");
            this.assignOrderData.order_booking_date = this.dataTimeFormat(item.due_date,"YYYY-MM-DD");
            this.assignOrderData.order_booking_time = { hours: '07', minutes: '00' };

            // Prepare assign_duration_type
            // Check if assign_duration is 8 then mark full day
            if (item.assigned_duration === 8) {
                this.assignOrderData.assigned_duration = 8;
                this.assignOrderData.assigned_duration_type = "full_day";
            }
            else {
                this.assignOrderData.assigned_duration = 2;
                this.assignOrderData.assigned_duration_type = "hours";
            }

            $("#assignOrderModal").modal({
                backdrop: "static",
                keyboard: false,
            });
            $("#assignOrderModal").modal("show");
            return false;
        },
        assignOrder() {
            this.isLoading = true;
            if(typeof this.assignOrderData.handyman_id === 'undefined' ||this.assignOrderData.handyman_id.length === 0) {
                this.$notification('error', "Please assign at-least one handyman to the order.");
                this.isLoading = false;
                return;
            }
            const data = this.assignOrderData;
            axios
                .post("/admin/orders/create-and-assign", data)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.enggDocReady = false;
                        this.isLoading = false;
                        $("#assignOrderModal").modal("hide");
                    }
                    this.$notification(response.data.status, response.data.message);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        cancelItemDrop() {
            $("#assignOrderModal").modal("hide");
        },
        prepareDateRange(action) {
            let startDate = this.moment(this.startDate);
            let endDate = this.moment(this.endDate);
            let incrementOrDecrement = 'month';
            if(action === 'prev') {
                // Check if search type is week
                if(['last_week', 'this_week', 'next_week'].includes(this.filters.searchType)) {
                    incrementOrDecrement = 'week';
                } else if(['last_year', 'this_year', 'next_year'].includes(this.filters.searchType)) {
                    incrementOrDecrement = 'year';
                } else {
                    incrementOrDecrement = 'month';
                }
                this.startDate = startDate.subtract(1, incrementOrDecrement);
                this.endDate = endDate.subtract(1, incrementOrDecrement);
            }
            else if(action === 'next') {
                // Check if search type is week
                if(['last_week', 'this_week', 'next_week'].includes(this.filters.searchType)) {
                    incrementOrDecrement = 'week';
                } else if(['last_year', 'this_year', 'next_year'].includes(this.filters.searchType)) {
                    incrementOrDecrement = 'year';
                } else {
                    incrementOrDecrement = 'month';
                }
                this.startDate = startDate.add(1, incrementOrDecrement);
                this.endDate = endDate.add(1, incrementOrDecrement);
            }
            this.getDueDateSummary();
        },
        changeFilterType() {
            //this.getDueDateSummary();
            if(this.filters.searchType === 'last_week') {
                this.startDate = this.moment().subtract(1, 'week').startOf('isoWeek');
                this.endDate = this.moment().subtract(1, 'week').endOf('isoWeek');
            } else if(this.filters.searchType === 'this_week') {
                this.startDate = this.moment().startOf('isoWeek');
                this.endDate = this.moment().endOf('isoWeek');
            } else if(this.filters.searchType === 'next_week') {
                this.startDate = this.moment().add(1, 'week').startOf('isoWeek');
                this.endDate = this.moment().add(1, 'week').endOf('week');
            } else if(this.filters.searchType === 'last_month') {
                this.startDate = this.moment().subtract(1, 'month').startOf('month');
                this.endDate = this.moment().subtract(1, 'month').endOf('month');
            } else if(this.filters.searchType === 'this_month') {
                this.startDate = this.moment().startOf('month');
                this.endDate = this.moment().endOf('month');
            } else if(this.filters.searchType === 'next_month') {
                this.startDate = this.moment().add(1, 'month').startOf('month');
                this.endDate = this.moment().add(1, 'month').endOf('month');
            } else if(this.filters.searchType === 'last_year') {
                this.startDate = this.moment().subtract(1, 'year').startOf('year');
                this.endDate = this.moment().subtract(1, 'year').endOf('year');
            } else if(this.filters.searchType === 'this_year') {
                this.startDate = this.moment().startOf('year');
                this.endDate = this.moment().endOf('year');
            } else if(this.filters.searchType === 'next_year') {
                this.startDate = this.moment().add(1, 'year').startOf('year');
                this.endDate = this.moment().add(1, 'year').endOf('year');
            }

            this.getDueDateSummary();
        }
    }
}
</script>
